<template>
  <collapse-default :id="'local_ocorrencia'"
                    :condition="local">
    <template v-slot:header>
      Local da Ocorrência {{ !local?' - Nenhum informado':'' }}
    </template>

    <template v-slot:content>
      <div v-if="local"
           class="row p-2">
        <div class="col">
          <label class="resumo-show_label">Tipo</label>
          <div class="resumo-show_sublabel">
            {{ tipos[local.sub_tipo] }}
          </div>
        </div>
        <div class="col">
          <label class="resumo-show_label">Descrição</label>
          <div class="resumo-show_sublabel">
            {{ local.descricao || tipos[local.sub_tipo] }}
          </div>
        </div>
      </div>
      <div v-if="local && local.endereco && local.tipo !== 'IGNORADO'"
           class="resumo-show_header--shadow">
        <div class="resumo-show_header--blue">
          {{ local.endereco.logradouro || 'Não informado' }}
        </div>
        <div class="pl-4 pl-4 row">
          <div class="col-10">
            <div class="row">
              <div class="col">
                <label class="resumo-show_header--label">CEP</label>
                <div class="resumo-show_header--sublabel">
                  {{ local.endereco.cep || 'Não informado' }}
                </div>
              </div>
              <div class="col">
                <label class="resumo-show_header--label">Número</label>
                <div class="resumo-show_header--sublabel">
                  {{ local.endereco.numero || 'Não informado' }}
                </div>
              </div>
              <div class="col">
                <label class="resumo-show_header--label">Complemento</label>
                <div class="resumo-show_header--sublabel">
                  {{ local.endereco.complemento || 'Não informado' }}
                </div>
              </div>
              <div class="col">
                <label class="resumo-show_header--label">Bairro</label>
                <div class="resumo-show_header--sublabel">
                  {{ local.endereco.bairro || 'Não informado' }}
                </div>
              </div>
              <div class="col">
                <label class="resumo-show_header--label">Cidade</label>
                <div class="resumo-show_header--sublabel">
                  {{ local.endereco.cidade || 'Não informado' }}
                </div>
              </div>
              <div class="col">
                <label class="resumo-show_header--label">UF</label>
                <div class="resumo-show_header--sublabel">
                  {{ local.endereco.uf || 'Não informado' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </collapse-default>
</template>

<script>
  import CollapseDefault from "./CollapseDefault"

  export default {
    name: "LocalOcorrenciaCollapse",
    components: {
      CollapseDefault
    },
    props: {
      local: { type: Object, default: () => ({}) }
    },
    data () {
      return {
        tipos: {
          'hospital': 'Hospital',
          'outros estabelecimentos de saude': 'Outros estabelecimentos de saúde',
          'domicilio': 'Domicílio',
          'outros': 'Outros',
          'ignorado': 'Ignorado',
        }
      }
    }
  }
</script>

<style scoped lang="scss">
 @import "../../../../scss/_components/resumos";
</style>
